

export const renderConditions = {

    checkIfQuantible : (formData) => {
        return true
    },
    getQuantible : (formData) => {
        return "TEMPORARY"
    },
    getMultiTenant:(formData) => {
        return formData?.isMultiTenant || false
    }


}


